import { Component, EventEmitter, forwardRef, Host, Input, OnInit, Optional, Output, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';
import * as moment from 'moment';
import 'moment/locale/th';
import { UserFactory } from 'src/app/core/user.factory';
import { FormControlBase } from '../form-control-base';
import { TranstationFactory } from 'src/app/core/translation.factory';

@Component({
  selector: 'app-input-dp-locale',
  templateUrl: './input-dp-locale.component.html',
  styleUrls: ['./input-dp-locale.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpLocaleComponent),
      multi: true
    },
  ]
})
export class InputDpLocaleComponent extends FormControlBase<any> implements OnInit {

  public lang: { key, title, img };
  private langs: { key, title, img }[] = [
    { key: 'th', title: 'ไทย', img: 'assets/icons/langs/thailand-flag-icon-64.png' },
    { key: 'en', title: 'English', img: 'assets/icons/langs/united-kingdom-flag-icon-64.png' },
  ];

  @Input() btnClass = 'btn-white';
  @Input() isChangeLang = true;
  @Output() change: EventEmitter<string> = new EventEmitter();

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private localize: LocalizeRouterService,
    private userFactory: UserFactory,
    private transtationFactory: TranstationFactory
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.setLang(this.translate.currentLang);
  }

  changeTranslate(lang: string) {
    this.change.emit(lang);
    this.setLang(lang);
  }

  setLang(lang: string) {
    this.writeValue(lang);
    this.lang = this.langs.filter((item) => {
      return item.key === lang;
    }).shift();

    if (!this.lang) {
      this.lang = this.langs.shift();
    }

    if (this.isChangeLang) {
      // set moment.js
      moment.locale(lang);
      this.localize.changeLanguage(lang);
      this.userFactory.setCurrentLang(lang);
      this.translate.getTranslation(lang).subscribe((res: Object) => {
        this.transtationFactory.set(res);
    });
    }
  }
}
